"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetObjectValue = void 0;
const set_to_object_1 = require("./object/set-to-object");
/**
 * @deprecated Use SetToObject instead
 */
function SetObjectValue(obj, path, value) {
    (0, set_to_object_1.SetToObject)(obj, path, value);
}
exports.SetObjectValue = SetObjectValue;
